import Shepherd from 'shepherd.js';
import { TOUR_BUTTONS } from '../shepherd-defaults';
import { waitForElement } from '../shepherd.utils';

type ShepherdTour = InstanceType<typeof Shepherd.Tour>;

export const SCHEDULE_PAGE_TOUR = 'schedule-page';

/**
 * `/schedule` (My activities): Hosting → Upcoming → Requested tabs.
 */
export function buildSchedulePageTour(tour: ShepherdTour): void {
  tour.addStep({
    id: 'schedule-tab-hosting',
    title: 'Tip',
    text: 'Activities you create and host appear under Hosting. If this is empty, use Post activity to publish a round.',
    attachTo: { element: '[data-tour="schedule-tab-hosting"]', on: 'bottom' },
    buttons: [TOUR_BUTTONS.skip, TOUR_BUTTONS.next],
    canClickTarget: true,
    beforeShowPromise() {
      return waitForElement('[data-tour="schedule-tab-hosting"]', 5000).then(() => undefined);
    },
  });

  tour.addStep({
    id: 'schedule-tab-upcoming',
    title: 'Tip',
    text: 'Rounds you have joined and that are confirmed show under Upcoming. If it is empty, create an activity or join one from Explore.',
    attachTo: { element: '[data-tour="schedule-tab-upcoming"]', on: 'bottom' },
    buttons: [TOUR_BUTTONS.back, TOUR_BUTTONS.next],
    canClickTarget: true,
    beforeShowPromise() {
      return waitForElement('[data-tour="schedule-tab-upcoming"]', 5000).then(() => undefined);
    },
  });

  tour.addStep({
    id: 'schedule-tab-requested',
    title: 'Tip',
    text: 'Join requests you have sent—and their status—show under Requested.',
    attachTo: { element: '[data-tour="schedule-tab-requested"]', on: 'bottom' },
    buttons: [TOUR_BUTTONS.back, TOUR_BUTTONS.finish],
    canClickTarget: true,
    beforeShowPromise() {
      return waitForElement('[data-tour="schedule-tab-requested"]', 5000).then(() => undefined);
    },
  });
}
